import { Component, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { UserService } from "src/app/core/auth";
import { NoticePageComponent } from "./core/layout/notice-page.component";

@Component({
  selector: "mr-vendor-portal",
  template: `
    <mr-notice-page
      message="For access regarding your order and appointment information, please click on the button below to be redirected to Insight Portal."
      buttonText="Go to Insight Portal"
      link="https://b2c-insight.capstonelogistics.com"
    ></mr-notice-page>
  `,
  imports: [NoticePageComponent],
})
export class VendorPortalComponent {}

export const NonVendorRedirectGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const router = inject(Router);
  const user = inject(UserService);

  await user.isLoaded;

  return user.isVendor() ? true : router.parseUrl("/");
};
